export default class YouTube {
	constructor(element) {
		this.element = element;
		this.videoContainer = this.element.querySelector('.js-video');
		this.poster = this.element.querySelector('.js-poster');
		this.videoId = this.element.dataset.videoId;
		this.playerReady = false;
		this.options = {
			rel: 0,
			autoplay: this.poster ? 1 : 0,
		};

		YouTube.instances.push(this);

		if (this.videoId) {
			YouTube.loadScript();
		} else {
			console.error("Impossible d'initialiser vidéo sans ID youtube.");
		}
	}

	setOptions() {
		if ('noControls' in this.element.dataset) {
			this.options.controls = 0;
		}
	}

	static loadScript() {
		if (!YouTube.isScriptLoading) {
			YouTube.isScriptLoading = true;

			const script = document.createElement('script');
			script.src = 'https://www.youtube.com/iframe_api';
			document.body.appendChild(script);
		}
	}

	init() {
		this.setOptions();
		this.initPlayer = this.initPlayer.bind(this);

		if (this.poster) {
			this.element.addEventListener('click', this.initPlayer);
		} else {
			this.initPlayer();
		}
	}

	initPlayer(event) {
		if (event) {
			this.element.removeEventListener('click', this.initPlayer);
		}

		this.player = new YT.Player(this.videoContainer, {
			height: '100%',
			width: '100%',
			videoId: this.videoId,
			playerVars: this.options,
			events: {
				onReady: () => {
					this.playerReady = true;

					const observer = new IntersectionObserver(this.watch.bind(this), {
						rootMargin: '0px 0px 0px 0px',
					});
					observer.observe(this.element);
				},
				onStateChange: (event) => {
					if (event.data == YT.PlayerState.PLAYING) {
						YouTube.pauseAll(this);
					} else if (event.data == YT.PlayerState.ENDED) {
						this.player.seekTo(0);
						this.player.pauseVideo();
					}
				},
			},
		});
	}

	watch(entries) {
		if (this.playerReady && !entries[0].isIntersecting) {
			this.player.pauseVideo();
		}
	}

	static pauseAll(currentInstance) {
		for (let i = 0; i < YouTube.instances.length; i++) {
			const instance = YouTube.instances[i];
			if (instance.playerReady && instance !== currentInstance) {
				instance.player.pauseVideo();
			}
		}
	}
	static initAll() {
		document.documentElement.classList.add('is-video-ready');

		for (let i = 0; i < YouTube.instances.length; i++) {
			const instance = YouTube.instances[i];
			instance.init();
		}
	}
}

YouTube.instances = [];
window.onYouTubeIframeAPIReady = YouTube.initAll;
